(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initSlider(sliderEl) {
      var rangeMax = parseFloat(sliderEl.dataset.rangeMax);
      var initMin  = parseFloat(sliderEl.dataset.initMin);
      var initMax  = parseFloat(sliderEl.dataset.initMax);
      var symbol   = sliderEl.dataset.currencySymbol || '';

      var minRange = sliderEl.querySelector('[data-target="min"]');
      var maxRange = sliderEl.querySelector('[data-target="max"]');
      var fill     = sliderEl.querySelector('.price-slider__track-fill');
      var minLabel = sliderEl.querySelector('.price-slider__label--min');
      var maxLabel = sliderEl.querySelector('.price-slider__label--max');

      var priceFacet = sliderEl.closest('price-facet-component');
      var minInput   = priceFacet ? priceFacet.querySelector('[ref="minInput"]') : null;
      var maxInput   = priceFacet ? priceFacet.querySelector('[ref="maxInput"]') : null;

      minRange.value = initMin;
      maxRange.value = initMax;

      // ── Repaint track fill + labels ──
      function repaint(lo, hi) {
        var pctLo = (lo / rangeMax) * 100;
        var pctHi = (hi / rangeMax) * 100;
        fill.style.left  = pctLo + '%';
        fill.style.width = (pctHi - pctLo) + '%';
        if (minLabel) minLabel.textContent = symbol + Math.round(lo);
        if (maxLabel) maxLabel.textContent = symbol + Math.round(hi);
      }

      // ── Write plain integers into theme inputs + fire change on price-facet-component ──
      // Theme's convertMoneyToMinorUnits() multiplies by 100 to get minor units,
      // so we pass plain integers (e.g. 500 for ₹500) not minor units (50000).
      // Empty string = no bound (theme deletes that URL param).
      function commitToTheme(lo, hi) {
        if (!minInput || !maxInput) return;
        minInput.value = lo > 0 ? String(Math.round(lo)) : '';
        maxInput.value = hi < rangeMax ? String(Math.round(hi)) : '';
        // Fire change on the custom element — this is what on:change="/updatePriceFilterAndResults" listens to
        priceFacet.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // ── While dragging: repaint only, no filter call ──
      function onMinInput() {
        var lo = parseFloat(minRange.value);
        var hi = parseFloat(maxRange.value);
        if (lo > hi) { lo = hi; minRange.value = lo; }
        repaint(lo, hi);
      }

      function onMaxInput() {
        var lo = parseFloat(minRange.value);
        var hi = parseFloat(maxRange.value);
        if (hi < lo) { hi = lo; maxRange.value = hi; }
        repaint(lo, hi);
      }

      // ── On pointer release: commit to theme + trigger filter ──
      function onSettle() {
        var lo = parseFloat(minRange.value);
        var hi = parseFloat(maxRange.value);
        commitToTheme(lo, hi);
      }

      minRange.addEventListener('input',  onMinInput);
      maxRange.addEventListener('input',  onMaxInput);
      minRange.addEventListener('change', onSettle);
      maxRange.addEventListener('change', onSettle);

      repaint(initMin, initMax);
    }

    function initAll() {
      document.querySelectorAll('.price-slider:not([data-slider-ready])').forEach(function (el) {
        el.setAttribute('data-slider-ready', '1');
        initSlider(el);
      });
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('facets:updated', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
